<template>
  <div class="categories-switch" @click="click">
    <label :class="'ebay-switch' + (modelValue? ' on':'')">
      <div class="ebay-slider"/>
    </label>
    <u class="label blue font14" >{{label}}</u>
  </div>
</template>

<script setup>
import {defineEmits, defineProps} from "vue";

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  label: {
    type:String,
    default: '',
  },
})

function click(){
  emit('update:modelValue', !props.modelValue)
}
</script>

<style scoped>
.categories-switch {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.ebay-switch {
  position: relative;
  width: 51px;
  height: 26px;
  margin-right: 10px !important;
  flex-shrink: 0
}

.ebay-switch .ebay-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 13px;
}

.ebay-switch .ebay-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  border-radius: 13px;
  left: 5px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}

.on .ebay-slider {
  background-color: #FA4B48;
}

.on .ebay-slider:before {
  transform: translateX(22px);
}
.label {
  white-space: normal;
  float: right;
}
</style>